export default __webpack_public_path__ + "static/media/util2.affe9f1f.jpg";